import type { Language } from '@magicschool/supabase/types';
import { directionOfLanguage } from './textDirection';

export function isLanguageRightToLeft(language: Language): boolean {
  return directionOfLanguage(language) === 'rtl';
}

export const TRANSLATION_REFRESH_TRACKER_COOKIE = 'translation-refresh';
